import React from 'react';
import Demo from './Demo';
import './Demos.css';

const Demos = () => {
	return (
		<section id="Demos" className="showcase">
			<div className="container-fluid p-0">
				<Demo title="3d demo" description="In this video you can see how the real movements of Oscar is reproduced on two humanoid avatars." video="DBOP3YzgEqU" isVideoLeft={true} />
				<Demo
					title="2d demo "
					description="With this video we show how easily it is to share your movements with f.ex. a GIF to your friend. As you can see it is possible to make 2D humanoid characters to mimic the movements of Oscar."
					video="rPTokdhdR8g"
					isVideoLeft={false}
				/>
			</div>
		</section>
	);
};

export default Demos;
